import {Component, OnInit} from '@angular/core';
import {ReporterService} from '../../services/reporter.service';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {DadConfigService} from '../../services/dad-config.service';
import {Reporter} from '../../models/models';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {BaseClientComponent} from '../../../components/base-client.component';

@Component({
  selector: 'app-list-reporters-component',
  templateUrl: './list-reporters.component.html',
  styleUrls: ['./list-reporters.component.scss'],
  host: {class: 'sym-page'}
})
export class ListReportersComponent extends BaseClientComponent implements OnInit {

  loading = true;
  loadError = false;
  reportersList: Reporter[] = [];
  dadConfigNames: string[];
  searchQuery = '';

  constructor(
    public authenticationService: AuthenticationService,
    private reporterService: ReporterService,
    private utilsService: UtilsService,
    private dadConfigService: DadConfigService) {
    super();
  }

  ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.retrieveListReporters();
      this.retrieveListDadConfigs();
    });
    this.subscriptions.push(response$);
  }

  private retrieveListDadConfigs() {
    this.dadConfigService.getAllDadConfigsNames().subscribe({
        next: res => {
          this.dadConfigNames = res.filter(configName => !!configName['name']).map(r => {
            return r['name'];
          });
          this.utilsService.unlockUi();
          this.loading = false;
        },
        error: () => {
          this.dadConfigNames = [];
          this.utilsService.unlockUi();
          this.loading = false;
          this.utilsService.displayMessage('The DAD configs could not be loaded', 'Please try again later.', 'error');
        }
      }
    );
  }

  private retrieveListReporters() {
    this.reporterService.getReporters().subscribe({
        next: res => {
          this.reportersList = res.sort((a, b) => a.group > b.group ? 1 : -1);
          this.loadError = false;
        },
        error: () => {
          this.reportersList = [];
          this.loadError = true;
          this.utilsService.displayMessage('The reporters could not be loaded', 'Please try again later.', 'error');
        }
      }
    );
  }

  getDadReporterFormDadConfig(reporter: Reporter, dadConfigName: string) {
    const dadReporters = reporter.billingAccount.dadReporters;
    return dadReporters.find(reporter => reporter.dadConfig === dadConfigName) ? dadReporters.find(reporter => reporter.dadConfig === dadConfigName).dadReporter : reporter.billingAccount.name;
  }

  reportersWithTheSameGroup(group: string): Reporter[] {
    return this.reportersList.filter(reporter => reporter.group === group);
  }

  get uniqueGroups(): string[] {
    return [...new Set(this.reportersList.map(r => r.group))];
  }

  get filteredGroups(): string[] {
    if (!this.searchQuery) { return this.uniqueGroups; }
    const q = this.searchQuery.toLowerCase();
    return this.uniqueGroups.filter(group =>
      group?.toLowerCase().includes(q) ||
      this.reportersWithTheSameGroup(group).some(r =>
        r.billingAccount?.name?.toLowerCase().includes(q) ||
        r.billingAccount?.shortname?.toLowerCase().includes(q) ||
        r.billingAccount?.customerId?.toString().includes(q)
      )
    );
  }

  filteredReportersInGroup(group: string): Reporter[] {
    const reporters = this.reportersWithTheSameGroup(group);
    if (!this.searchQuery) { return reporters; }
    const q = this.searchQuery.toLowerCase();
    return reporters.filter(r =>
      r.billingAccount?.name?.toLowerCase().includes(q) ||
      r.billingAccount?.shortname?.toLowerCase().includes(q) ||
      r.billingAccount?.customerId?.toString().includes(q) ||
      r.group?.toLowerCase().includes(q)
    );
  }
}
